import { schema } from 'normalizr'

const tableOrder = new schema.Entity('tableOrders')

export default tableOrder
